<template>
  <ClientOnly>
    <Paginate
      :page-count="pageCount"
      :page-range="3"
      :margin-pages="2"
      :model-value="value"
      :click-handler="clickHandler"
      prev-text="<"
      next-text=">"
      container-class="flex justify-center"
      page-link-class="page-link"
      prev-link-class="page-link"
      next-link-class="page-link"
      no-li-surround
      active-class="active"
    />
  </ClientOnly>
</template>

<script>
import Paginate from 'vuejs-paginate-next'

export default {
  components: { Paginate },

  props: {
    value: { type: Number, default: 1 },
    pageCount: { type: Number, required: true },
    clickHandler: { type: Function, required: true },
  },
}
</script>

<style lang="scss" scoped>
:deep() {
  .page-link {
    @apply block w-8 h-8 rounded-lg bg-white text-center text-sm leading-8 mx-1 cursor-pointer;
    &:hover:not(.disabled) {
      @apply bg-gray-dark text-white;
    }
    &:focus {
      @apply outline-none;
    }
    &.active {
      color: white !important;
      @apply bg-gray-dark;
    }
    &.disabled {
      @apply border-gray-500 text-gray-500 cursor-not-allowed;
      &:first-child, &:last-child {
        @apply hidden;
      }
    }
  }
}
</style>
